import { isProductOptionModelList } from "../../../../types/helpers/isProductOptionModelList";
import { DecoratorResult } from "../types";
export function calloutDecorator(productOption, i18n) {
    const result = new DecoratorResult();
    const reservedCalloutStrings = {
        legacy_recommended: "recommendedCallout",
        legacy_new: "newCallout",
        legacy_incompatible: "incompatibleLabel",
        legacy_outofstock: "outOfStockCallout",
    };
    if (isProductOptionModelList(productOption)) {
        productOption.choices.map((choice) => {
            choice.callouts?.map((callout) => {
                Object.entries(reservedCalloutStrings).map(([reservedString, localizationKey]) => {
                    if (callout.text.toLowerCase() === reservedString) {
                        const calloutTranslated = i18n(localizationKey);
                        result.addMutation({
                            type: "update",
                            reason: `Reserved callout text ${reservedString} should use translations of ${localizationKey}`,
                            oldState: callout.text,
                            newState: calloutTranslated,
                        });
                        callout.text = calloutTranslated;
                    }
                });
            });
        });
    }
    return result;
}
//# sourceMappingURL=callout-decorator.js.map